import { FC } from "react";
import Icon from 'components/icon';
import { Link } from "react-router-dom";

import './footer.scss';

const AppFooter: FC = () => (
  <footer className="app-footer">
    <div className="container-fluid">
      <div className="footer-top-section">
        <div className="logo">
          <Icon name="sasr" />
        </div>
        <div className="links">
          <ul>
            <li>
              <Link to="/terms-and-conditions">
                Terms &amp; Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacy">
                Privacy
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="copyright">
        <p>Hireflex &copy; {new Date().getFullYear()}. All rights reserved.</p>
      </div>
      <div className="app-version">
        <p>App version: {process.env.REACT_APP_VERSION}</p>
      </div>
    </div>
  </footer>
);

export default AppFooter;